import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DisconnectFacebookModalComponent } from './disconnect-facebook-modal.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [DisconnectFacebookModalComponent],
})
export class DisconnectFacebookModalModule {}
